import { MiddotSeparated } from "@indietabletop/appkit";
import { type ReactElement, type ReactNode, cloneElement } from "react";
import { item, list } from "./style.css.ts";

export function ListItem(props: {
  heading: string;
  type?: string;
  summary: ReactNode;
  render?: ReactElement;
  aside?: ReactNode;
}) {
  const { render, heading, type, summary, aside } = props;
  const element = render ?? <div />;

  return (
    <li className={item.root}>
      {cloneElement(
        element,
        { className: item.container },
        <>
          <div className={item.heading}>{heading}</div>

          <MiddotSeparated className={item.summary}>
            {type && <em>{type}</em>}
            {summary}
          </MiddotSeparated>
        </>,
      )}

      {aside}
    </li>
  );
}

export function ListView(props: {
  children: ReactNode;
  empty: string;
  theme?: "PRIMARY" | "SECONDARY";
}) {
  const { children, empty, theme } = props;

  return (
    <>
      <ul className={list.container({ theme })}>{children}</ul>
      <div className={list.empty}>{empty}</div>
    </>
  );
}
